import {
  BarChart3,
  Bell,
  Boxes,
  FileText,
  Grid3X3,
  Home,
  Link as LinkIcon,
  MessageSquare,
  Search,
  Settings,
  ShieldCheck,
  Truck,
  User,
  Users
} from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";
import logo from "../../assets/brand-logo.png";
import { adminNav } from "../../data/navigation";

const iconMap = new Map([
  ["Tổng quan", Home],
  ["Đơn hàng", FileText],
  ["Sản phẩm", Boxes],
  ["Kho hàng", Grid3X3],
  ["Nhập hàng", Truck],
  ["Nhà cung cấp", Truck],
  ["Khách hàng", Users],
  ["B2B / Đại lý", Users],
  ["Marketplace", LinkIcon],
  ["Chat", MessageSquare],
  ["Tài chính", BarChart3],
  ["Đối soát", BarChart3],
  ["Báo cáo", BarChart3],
  ["Bảo hành / Trả hàng", ShieldCheck],
  ["Thành viên", Users],
  ["Vai trò", ShieldCheck],
  ["Audit", FileText],
  ["Cài đặt", Settings]
]);

const navClass = ({ isActive }: { isActive: boolean }) => (isActive ? "active" : undefined);

export function AdminShell() {
  return (
    <div className="admin">
      <aside className="side">
        <NavLink className="side-brand" to="/admin">
          <img src={logo} alt="Logo Siêu Thị Ưa Thích" />
          <div>
            <strong>SIÊU THỊ ƯA THÍCH</strong>
            <span>Hệ thống quản trị bán hàng</span>
          </div>
        </NavLink>
        <nav className="side-nav" aria-label="Điều hướng admin">
          {adminNav.map((item) => {
            const Icon = iconMap.get(item.label) ?? Grid3X3;
            return (
              <NavLink key={item.href} to={item.href} className={navClass} end={item.href === "/admin"}>
                <Icon aria-hidden="true" />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="side-foot">Phiên bản thiết kế V3.1 · Quản trị bán hàng</div>
      </aside>
      <section className="workspace">
        <header className="admin-top">
          <form className="admin-search" onSubmit={(event) => event.preventDefault()}>
            <Search aria-hidden="true" />
            <input placeholder="Tìm đơn hàng, SKU, khách hàng, nhà cung cấp..." />
          </form>
          <div className="top-actions">
            <button className="top-btn" type="button">
              <Bell aria-hidden="true" />
              <span>Thông báo</span>
            </button>
            <button className="top-btn" type="button">
              <User aria-hidden="true" />
              <span>Phạm Trúng</span>
            </button>
          </div>
        </header>
        <Outlet />
      </section>
      <nav className="mobile-admin-nav" aria-label="Điều hướng admin di động">
        <NavLink to="/admin" className={navClass} end>
          <Home aria-hidden="true" />
          Tổng
        </NavLink>
        <NavLink to="/admin/orders" className={navClass}>
          <FileText aria-hidden="true" />
          Đơn
        </NavLink>
        <NavLink to="/admin/inventory" className={navClass}>
          <Grid3X3 aria-hidden="true" />
          Kho
        </NavLink>
        <NavLink to="/admin/chat" className={navClass}>
          <MessageSquare aria-hidden="true" />
          Chat
        </NavLink>
        <NavLink to="/admin/settings" className={navClass}>
          <Settings aria-hidden="true" />
          Cài
        </NavLink>
      </nav>
    </div>
  );
}
